import moment from 'moment';

export function formatDate(dateInput) {
  let publishedDate = moment(dateInput).format("DD MMM[. '] YY");
  return publishedDate;
}

export function slashedDate(dateInput) {
  let publishedDate = new Date(dateInput);
  let day = publishedDate.toLocaleDateString('en-gb', {
    day: '2-digit',
  });
  let month = publishedDate.toLocaleDateString('en-gb', {
    month: '2-digit',
  });
  let year = publishedDate.toLocaleDateString('en-gb', {
    year: '2-digit',
  });
  return day + '/' + month + '/' + year;
}

export function dashedDate(dateInput) {
  let publishedDate = new Date(dateInput);
  let day = publishedDate.toLocaleDateString('en-gb', {
    day: '2-digit',
  });
  let month = publishedDate.toLocaleDateString('en-gb', {
    month: '2-digit',
  });
  let year = publishedDate.toLocaleDateString('en-gb', {
    year: 'numeric',
  });
  return year + '-' + month + '-' + day;
}

export function fullDate(dateInput) {
  let publishedDate = new Date(dateInput);
  return publishedDate.toLocaleDateString('en-gb', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function shortDay(dateInput) {
  let publishedDate = new Date(dateInput);
  return publishedDate.toLocaleDateString('en-gb', {
    weekday: 'short',
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
}

export function eventCardDate(dateInput) {
  let publishedDate = new Date(dateInput);
  let weekday = publishedDate.toLocaleDateString('en-gb', {
    weekday: 'short',
  });
  let day = publishedDate.toLocaleDateString('en-gb', {
    day: '2-digit',
  });
  let month = publishedDate.toLocaleDateString('en-gb', {
    month: 'short',
  });
  let year = publishedDate.toLocaleDateString('en-gb', {
    year: '2-digit',
  });
  return weekday + ', ' + day + ' ' + month + ' ‘' + year;
}

export function calendarDate(dateInput) {
  let publishedDate = new Date(dateInput);
  let month = publishedDate.toLocaleDateString('en-gb', {
    month: 'short',
  });
  let year = publishedDate.toLocaleDateString('en-gb', {
    year: '2-digit',
  });
  return month + '. ‘' + year;
}

export function slashedDatePlusWeekday(dateInput) {
  let publishedDate = new Date(dateInput);
  let day = publishedDate.toLocaleDateString('en-gb', {
    day: '2-digit',
  });
  let month = publishedDate.toLocaleDateString('en-gb', {
    month: '2-digit',
  });
  let year = publishedDate.toLocaleDateString('en-gb', {
    year: '2-digit',
  });
  let weekday = publishedDate.toLocaleDateString('en-gb', {
    weekday: 'long',
  });
  return day + '/' + month + '/' + year + ' (' + weekday + ')';
}
